const API_ERROR_KEYS = {
  access: 'apiErrors.access',
  role_access: 'apiErrors.access',
  not_authorize: 'apiErrors.notAuthorized',
  field_required: 'apiErrors.fieldRequired',
  field_access: 'apiErrors.fieldAccess',
  order_field_update_failed: 'apiErrors.orderIdentifierSaveFailed',
  order_message_finished: 'apiErrors.orderMessageFinished',
  not_found: 'apiErrors.notFound',
  status_access: 'apiErrors.statusAccess',
  file_required: 'apiErrors.fileRequired',
  file_upload_error: 'apiErrors.fileUploadError',
  import_read_error: 'apiErrors.importReadError',
  import_empty: 'apiErrors.importEmpty',
  login: 'apiErrors.loginRequired',
  password: 'apiErrors.passwordRequired',
  code: 'apiErrors.invalidCredentials',
  lang_required: 'apiErrors.langRequired',
  invalid_lang: 'apiErrors.invalidLang'
};

export function translateApiError(error, t) {
  if (!error || typeof error !== 'object') {
    return String(error || t('errors.serverError'));
  }

  if (typeof error.code === 'number') {
    return t('errors.serverError');
  }

  const translationKey = API_ERROR_KEYS[error.code];
  return translationKey ? t(translationKey) : (error.message || t('errors.serverError'));
}

export function translateApiErrors(errors, t) {
  if (!Array.isArray(errors) || !errors.length) {
    return [t('errors.serverError')];
  }

  return errors.map(error => translateApiError(error, t));
}
